import { usePagination, DOTS } from "./usePagination";
import {
  ArrowContainer,
  ArrowIcon,
  PaginationContainer,
  PaginationItem,
  RightArrowIcon,
} from "./Pagination.styles";

const Pagination = ({
  currentPage,
  totalCount,
  perPage,
  onPageChange,
  siblingCount = 1,
  small,
}) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    perPage,
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const lastPage = paginationRange[paginationRange.length - 1];

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  return (
    <PaginationContainer $small={small}>
      <ArrowContainer
        disabled={currentPage === 1}
        onClick={onPrevious}
        $small={small}
      >
        <ArrowIcon $disabled={currentPage === 1} $small={small} />
      </ArrowContainer>
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return (
            <PaginationItem key={pageNumber + index} $small={small}>
              &#8230;
            </PaginationItem>
          );
        }

        return (
          <PaginationItem
            $small={small}
            key={pageNumber}
            selected={pageNumber === currentPage}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </PaginationItem>
        );
      })}
      <ArrowContainer
        disabled={currentPage === lastPage}
        onClick={onNext}
        $small={small}
      >
        <RightArrowIcon $disabled={currentPage === lastPage} $small={small} />
      </ArrowContainer>
    </PaginationContainer>
  );
};

export default Pagination;
